import React from 'react'
import MyBlock from './MyBlock'
import MyButton from '../form/MyButton'
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const MyBlockHeader = ({ header, options, isBack }) => {

	const navigate = useNavigate()

  return (
    <MyBlock>
        <div className='myBlockHeader'>
            <div className='myBlockHeader__blockLeft'>
                <h2>{ header }</h2>
				{
					isBack ?
						<MyButton
							onClick={e => navigate(-1)}
						>
							<ArrowBackIcon />
						</MyButton>
					: ''
				}
            </div>
            {
                options
            }
        </div>
    </MyBlock>
  )
}

export default MyBlockHeader